import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
    constructor(private activatedRoute: ActivatedRoute) {}

    public isActive(name: string): boolean {
        return (
            this.activatedRoute.snapshot.queryParams['featureFlag.' + name] ===
            'true'
        );
    }
}
